<template>
  <div>
    <v-toolbar style="margin-bottom:20px;">
      <v-btn icon @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>Invites</v-toolbar-title>
    </v-toolbar>
    <div class="wrapper">
      <v-card class="mx-auto">
        <v-list two-line subheader>
          <v-list-item v-for="invite in pendingInvites" :key="invite.index">
            <v-list-item-content>
              <v-list-item-title
                v-text="'List: ' + invite.list_name"
              ></v-list-item-title>
              <v-list-item-subtitle
                v-text="
                  'From: ' +
                    invite.from_user_name +
                    ' (' +
                    invite.from_user_email +
                    ')'
                "
              ></v-list-item-subtitle>
              <div class="invite-buttons-container">
                <v-btn @click="acceptInvite(invite.id, invite.list_id)">
                  ACCEPT
                </v-btn>
                <v-btn @click="declineInvite(invite.id)">
                  DECLINE
                </v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");
import firebase from "firebase";

export default {
  name: "Invites",
  data() {
    return {
      unsubscribeListener: null
    };
  },
  computed: {
    ...mapState(["pendingInvites", "currentUser", "userProfile"])
  },
  methods: {
    fetchInvites() {
      this.unsubscribeListener = fb.pendingListInvitesCollection
        .where("to_user_id", "==", this.currentUser.uid)
        .onSnapshot(querySnapshot => {
          let invites = [];

          querySnapshot.forEach(doc => {
            let invite = doc.data();
            invite.id = doc.id;
            invites.push(invite);
          });
          this.$store.commit("setPendingInvites", invites);
        });
    },
    acceptInvite(inviteId, listId) {
      let list = null;
      fb.listsCollection
        .doc(listId)
        .get()
        .then(doc => {
          list = doc.data();
          var newUserList = {
            createdOn: list.createdOn,
            total_items: list.total_items,
            items_bought: list.items_bought,
            list_name: list.list_name,
            list_info: list.list_info,
            list_type: list.list_type,
            list_id: listId,
            user_id: this.currentUser.uid,
            user_name: this.userProfile.name,
            user_role: "guest"
          };

          fb.userListsCollection
            .where("user_id", "==", this.currentUser.uid)
            .orderBy("sortOrder", "desc")
            .limit(1)
            .get()
            .then(snap => {
              var sortOrder = 1;
              if (snap.size > 0) {
                sortOrder = snap.docs[0].data().sortOrder + 1;
              }

              newUserList.sortOrder = sortOrder;

              fb.userListsCollection
                .add(newUserList)
                .then(adddedUserList => {
                  fb.listsCollection.doc(listId).update({
                    users: firebase.firestore.FieldValue.arrayUnion({
                      id: this.currentUser.uid,
                      userName: this.userProfile.name,
                      email: this.currentUser.email,
                      role: "guest"
                    })
                  });

                  fb.distinctListItemsCollection
                    .where("list_id", "==", listId)
                    .get()
                    .then(snap => {
                      snap.docs.forEach(doc => {
                        let newListItem = doc.data();
                        newListItem.user_list_id = adddedUserList.id;
                        newListItem.distinct_item_id = doc.id;
                        fb.listItemsCollection.add(newListItem).catch(err => {
                          console.log(err);
                        });
                        fb.pendingListInvitesCollection.doc(inviteId).delete();
                      });
                    })
                    .catch(err => {
                      console.log(err);
                    });
                })
                .catch(err => {
                  console.log(err);
                });
            })
            .catch(err => {
              console.log(err);
            });

          this.$router.back();
        })
        .catch(err => {
          console.log(err);
        });
    },
    declineInvite(inviteId) {
      fb.pendingListInvitesCollection
        .doc(inviteId)
        .delete()
        .then(() => {
          alert("Invite declined");
        });
    }
  },
  created() {
    this.fetchInvites();
  },
  destroyed() {
    this.unsubscribeListener();
  }
};
</script>

<style lang="scss">
.invite-buttons-container {
  margin-top: 15px;
}
</style>
